import { render } from "./UpdateTeamNameForm.vue?vue&type=template&id=9e634f1c"
import script from "./UpdateTeamNameForm.vue?vue&type=script&lang=js"
export * from "./UpdateTeamNameForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__